import React, { useState } from "react";
import icon1 from "../../assets/images/Constructionengineer.png";
import icon2 from "../../assets/images/administratorsystem.png";
import icon3 from "../../assets/images/icon3.png";
import icon4 from "../../assets/images/mobappicon.png";
import { Link } from "react-router-dom";
import "@fontsource/manrope";
import "@fontsource/syne";

const cards = [
  {
    icon: icon1,
    title: "Construction Management",
    desc: "Process Transformation, Business Model Transformation, Bringing in Nextgen Technology.",
  },
  {
    icon: icon2,
    title: "School Admin",
    desc: "End to end Automation Testing, Load Testing, Performance Testing, Backend system Testing.",
  },
  {
    icon: icon3,
    title: "Web Application Development",
    desc: "Scalable, secure, and responsive web applications tailored to business needs using modern technologies and cloud-native architectures.",
  },
  {
    icon: icon4,
    title: "Mobile Application",
    desc: "End to end Automation Testing, Load Testing, Performance Testing, Backend system Testing.",
  },
];

function AICard({ icon, title, desc }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="col-12 col-sm-6 col-lg-3">
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        data-aos="fade-up"
        data-aos-duration="3000"
        style={{
          height: "100%",
          borderRadius: 16,
          padding: "2rem 1.5rem",
          background: hovered
            ? "linear-gradient(135deg, #563D7C, #7b5ea7)"
            : "#fff",
          border: hovered
            ? "1px solid transparent"
            : "1px solid rgba(86,61,124,0.1)",
          boxShadow: hovered
            ? "0 12px 40px rgba(86,61,124,0.25)"
            : "0 2px 16px rgba(86,61,124,0.06)",
          transform: hovered ? "translateY(-5px)" : "translateY(0)",
          transition: "all 0.25s ease",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        {/* Icon box */}
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 14,
            background: hovered
              ? "rgba(255,255,255,0.15)"
              : "rgba(86,61,124,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background 0.25s",
          }}
        >
          <img
            src={icon}
            alt=""
            style={{
              width: 30,
              height: 30,
              objectFit: "contain",
              filter: hovered ? "brightness(10)" : "none",
              transition: "filter 0.25s",
            }}
          />
        </div>

        {/* Divider */}
        <div
          style={{
            width: 32,
            height: 2,
            borderRadius: 2,
            background: hovered
              ? "rgba(255,255,255,0.35)"
              : "rgba(86,61,124,0.2)",
            transition: "background 0.25s",
          }}
        />

        {title && (
          <h5
            style={{
              fontSize: "0.95rem",
              fontWeight: 700,
              color: hovered ? "#fff" : "#1a1a2e",
              margin: 0,
              lineHeight: 1.35,
              fontFamily: "'Syne', sans-serif",
              textTransform: "uppercase",
              letterSpacing: "0.03em",
              transition: "color 0.25s",
            }}
          >
            {title}
          </h5>
        )}

        {desc && (
          <p
            style={{
              fontSize: "0.855rem",
              color: hovered ? "rgba(255,255,255,0.8)" : "#666",
              lineHeight: 1.75,
              margin: 0,
              fontFamily: "'Manrope', sans-serif",
              transition: "color 0.25s",
            }}
          >
            {desc}
          </p>
        )}
      </div>
    </div>
  );
}

const AIinfo = () => {
  return (
    <div className="bg-white py-5">
      <div className="container" style={{ maxWidth: 1100 }}>
        {/* Heading */}
        <div className="text-center mb-5">
          <p
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "#563D7C",
              marginBottom: "0.5rem",
            }}
          >
            Why choose us
          </p>
          <h2
            className="display-6"
            data-aos="fade-up"
            data-aos-duration="3000"
            style={{
              fontWeight: 800,
              color: "#1a1a2e",
              fontFamily: "'Syne', sans-serif",
              letterSpacing: "0.02em",
              marginBottom: "0.75rem",
            }}
          >
            The Athees Info Advantage
          </h2>
          <div
            style={{
              width: 48,
              height: 3,
              background: "#563D7C",
              borderRadius: 2,
              margin: "0 auto",
              opacity: 0.5,
            }}
          />
        </div>

        {/* Cards */}
        <div className="row g-4">
          {cards.map((card, i) => (
            <AICard key={i} {...card} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIinfo;
